module.exports = __webpack_public_path__ + "img/home-hover.eaa84b91.svg";